import styles from "./Containers.module.css";

const InputCard = ({ children }) => {
  return <div className={styles.inputCard}>{children}</div>;
};

export default InputCard;
